import { lazy } from "react";

const MainPage = lazy(() => import("./views/home/index.js"));
const DispensariesManagementPage = lazy(() =>
  import("./views/management/DispensariesManagement.js")
);
const DispensariesBranchesPage = lazy(() =>
  import("./views/branches/index.js")
);
const AssignedPersonnelPage = lazy(() =>
  import("./views/assigned-personnel/AssignedPersonnel.js")
);

const routes = [
  {
    path: "/administration/medical-dispensaries",
    exact: true,
    name: "Dispensarios Médicos - Administración",
    component: MainPage
  },
  {
    path: "/administration/medical-dispensaries/new",
    exact: true,
    name: "Nuevo Dispensario Médico",
    component: DispensariesManagementPage
  },
  {
    path: "/administration/medical-dispensaries/edit/:id",
    exact: true,
    name: "Editar Dispensario Médico",
    component: DispensariesManagementPage
  },
  {
    path:
      "/administration/medical-dispensaries/edit/:dispensaryId/branches/new",
    exact: true,
    name: "Agregar Nueva Sucursal",
    component: DispensariesBranchesPage
  },
  {
    path:
      "/administration/medical-dispensaries/edit/:dispensaryId/branches/edit/:branchId",
    exact: true,
    name: "Editar Sucursal",
    component: DispensariesBranchesPage
  },
  {
    path:
      "/administration/medical-dispensaries/edit/:dispensaryId/branches/edit/:branchId/assigned-personnel/new",
    exact: true,
    name: "Agregar Personal Asignado",
    component: AssignedPersonnelPage
  },
  {
    path:
      "/administration/medical-dispensaries/edit/:dispensaryId/branches/edit/:branchId/assigned-personnel/edit/:personnelId",
    exact: true,
    name: "Editar Personal Asignado",
    component: AssignedPersonnelPage
  }
];

export default routes;
